import React from 'react'
import {
    RFPContext,
    WorkorderContext,
    useRFPState,
    useWorkorderState,
} from '../../contexts'
import { ScheduleHome } from './ScheduleHome'

export const ScheduleHomeRoot = () => {
    const workorderState = useWorkorderState()
    const rfpState = useRFPState()

    return (
        <WorkorderContext.Provider value={workorderState}>
            <RFPContext.Provider value={rfpState}>
                <ScheduleHome />
            </RFPContext.Provider>
        </WorkorderContext.Provider>
    )
}
